export default function faqSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Do you provide insurance services?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Yes, we provide Vehicle, Health, and Travel Insurance services."
                }
            },
            {
                "@type": "Question",
                "name": "Do you install CCTV cameras?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Yes, we provide CCTV sales, installation, and maintenance."
                }
            }
        ]
    };
}
